import { EditedParticipation } from "../../../Partner/EditedPartner";
import { Filter } from "../../ParticipationFunctions/Filtering";
import { offsetOneRow, offsetTwoRows, StateStyledCell } from "../../Styles/ParticipationTableStyles";
import { CellWithValidator, StickyHeader } from "../../../../components/Table/TableStyles";
import { ValidatedIcon, ValidateFilter, ValidateFilterValue } from "../../../../components/Controls/ValidateControl";
import { TextFilter } from "../../../../components/Form/FormStyles";

export function CommunitySiteCityHeader() {
	return (
		<StickyHeader
			style={{
				...offsetOneRow,
				width: '195px',
				minWidth: '195px',
				maxWidth: '195px'
			}}>
			Community site city
		</StickyHeader>
	)
}

export function CommunitySiteCityFilter({ filter, updateFilter }: { filter: Filter, updateFilter: (filter: Filter) => void }) {
	return (
		<StickyHeader style={{ ...offsetTwoRows }}>
			<CellWithValidator>
				<ValidateFilter
					value={
						filter?.CommunitySiteCityValidated ?? ValidateFilterValue.Unset
					}
					onChange={(e) =>
						updateFilter({ ...filter, CommunitySiteCityValidated: e.value })
					}
				/>
				<TextFilter
					value={filter?.CommunitySiteCity ?? ''}
					onChange={(e) =>
						updateFilter({ ...filter, CommunitySiteCity: e.target.value })
					}
				/>
			</CellWithValidator>
		</StickyHeader>
	)
}

export function CommunitySiteCityContent({ ppn }: { ppn: EditedParticipation }) {
	return (
		<StateStyledCell
			editStatus={ppn.EditStatus}
			modified={ppn.PlantingProjectId.modified}>
			<CellWithValidator>
				<span>
					{ppn.PlantingProject.CommunitySiteCityValidated && (
						<ValidatedIcon />
					)}
				</span>
				<span>{ppn.PlantingProject.CommunitySiteCity}</span>
			</CellWithValidator>
		</StateStyledCell>
	)
}